'use client';

import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import type { ReactNode } from 'react';

interface UiProviderProps {
  children: ReactNode;
}

/**
 * UiProvider - Wrapper for Ant Design ConfigProvider
 * Provides global configuration for all Ant Design components
 */
export function UiProvider({ children }: UiProviderProps) {
  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          fontSize: 14,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
        },
        components: {
          Button: {
            controlHeight: 32,
          },
          Input: {
            controlHeight: 32,
          },
          Select: {
            controlHeight: 32,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
